import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrowRightUpIcon } from './arrow-right-up-icon';
import { CameraTickIcon } from './camera-tick-icon';
import { ChevronLeftIcon } from './chevron-left-icon';
import { ChevronRightIcon } from './chevron-right-icon';
import { CircleIcon } from './circle-icon';
import { CloseIcon } from './close-icon';
import { EditIcon } from './edit-icon';
import { EraseIcon } from './erase-icon';
import { FormalIcon } from './formal-icon';
import { ImageIcon } from './image-icon';
import { PlayIcon } from './play-icon';
import { RectangleIcon } from './rectangle-icon';
import { RedoArrowIcon } from './redo-arrow-icon';
import { SaveIcon } from './save-icon';
import { ShapesIcon } from './shapes-icon';
import { StrokeWidthIcon } from './stroke-width-icon';
import { TelevisionIcon } from './television-icon';
import { TrashIcon } from './trash-icon';
import { UndoArrowIcon } from './undo-arrow-icon';
import { VideoIcon } from './video-icon';
import { ShowIcon } from './show-icon';
import { SlidesIcon } from './slides-icon';
import { FreedrawIcon } from './freedraw-icon';
import { LaserIcon } from './laser-icon';
import { RefreshIcon } from './refresh-icon';
import { SandglassIcon } from './sandglass-icon';
import { PauseIcon } from './pause-icon';
import { ArrowLeftIcon } from './arrow-left-icon';
import { ShareIcon } from './share-icon';
import { MessageCircleIcon } from './message-circle-icon';
import { PlusIcon } from './plus-icon';
import { SendIcon } from './send-icon';
import { CopyIcon } from './copy-icon';
import { FolderIcon } from './folder-icon';
import { MenuIcon } from './menu-icon';
import { PlayCircleIcon } from './play-circle-icon';
import { WarningIcon } from './warning-icon';
import { CutIcon } from './cut-icon';
import { DetailsIcon } from './details-icon';
import { LogoutIcon } from './logout-icon';
import { ExportIcon } from './export-icon';
import { UserIcon } from './user-icon';
import { VideoCutIcon } from './video-cut-icon';
import { TakeawaysIcon } from './takeaways-icon';
import { StrategyIcon } from './strategy-icon';
import { DecisionPointIcon } from './decision-point-icon';
import { QuizIcon } from './quiz-icon';
import { TranscriptionIcon } from './transcription-icon';
import { PlayFilledIcon } from './play-filled-icon';
import { ShareStrokeIcon } from './share-stroke-icon';
import { Menu04Icon } from './menu-04-icon';
import { StampIcon } from './stamp-icon';
import { VerticalDotsIcon } from './vertical-dots-icon';
import { CodeViewIcon } from './code-view-icon';
import { DownloadIcon } from './download-icon';
import { ClockIcon } from './clock-icon';
import { AiIcon } from './ai-icon';
import { UserCheckIcon } from './user-check-icon';
import { UserLockIcon } from './user-lock-icon';
import { RedactionIcon } from './redaction-icon';
import { ScreenshotIcon } from './screenshot-icon';
import { CalendarIcon } from './calendar-icon';
import { SecurityIcon } from './security-icon';
import { AudioIcon } from './audio-icon';
import { LockIcon } from './lock-icon';
import { Menu07Icon } from './menu-07-icon';
import { BarchartIcon } from './barchart-icon';
import { SearchIcon } from './search-icon';
import { ChevronUpIcon } from './chevron-up-icon';
import { ChevronDownIcon } from './chevron-down-icon';
import { TrashCrossIcon } from './trash-cross-icon';
import { MicrophoneOffIcon } from './microphone-off-icon';
import { MicrophoneIcon } from './microphone-icon';

@NgModule({
  exports: [
    AiIcon,
    ArrowLeftIcon,
    ArrowRightUpIcon,
    AudioIcon,
    BarchartIcon,
    CalendarIcon,
    CameraTickIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CircleIcon,
    ClockIcon,
    CloseIcon,
    CodeViewIcon,
    CopyIcon,
    CutIcon,
    DecisionPointIcon,
    DetailsIcon,
    DownloadIcon,
    EditIcon,
    EraseIcon,
    ExportIcon,
    FormalIcon,
    FolderIcon,
    FreedrawIcon,
    QuizIcon,
    ImageIcon,
    LaserIcon,
    LockIcon,
    LogoutIcon,
    Menu04Icon,
    MenuIcon,
    Menu07Icon,
    MessageCircleIcon,
    MicrophoneIcon,
    MicrophoneOffIcon,
    PauseIcon,
    PlayIcon,
    PlayCircleIcon,
    PlayFilledIcon,
    PlusIcon,
    RectangleIcon,
    RedactionIcon,
    RedoArrowIcon,
    RefreshIcon,
    SandglassIcon,
    SaveIcon,
    ScreenshotIcon,
    SearchIcon,
    SecurityIcon,
    SendIcon,
    ShapesIcon,
    ShareIcon,
    ShareStrokeIcon,
    ShowIcon,
    SlidesIcon,
    StampIcon,
    StrategyIcon,
    StrokeWidthIcon,
    TakeawaysIcon,
    TelevisionIcon,
    TranscriptionIcon,
    TrashIcon,
    TrashCrossIcon,
    UndoArrowIcon,
    UserCheckIcon,
    UserIcon,
    UserLockIcon,
    VerticalDotsIcon,
    VideoIcon,
    VideoCutIcon,
    WarningIcon,
  ],
  imports: [
    CommonModule,
    AiIcon,
    ArrowLeftIcon,
    ArrowRightUpIcon,
    AudioIcon,
    BarchartIcon,
    CalendarIcon,
    CameraTickIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CircleIcon,
    ClockIcon,
    CloseIcon,
    CodeViewIcon,
    CopyIcon,
    CutIcon,
    DecisionPointIcon,
    DetailsIcon,
    DownloadIcon,
    EditIcon,
    EraseIcon,
    ExportIcon,
    FormalIcon,
    FolderIcon,
    FreedrawIcon,
    QuizIcon,
    ImageIcon,
    LaserIcon,
    LockIcon,
    LogoutIcon,
    Menu04Icon,
    MenuIcon,
    Menu07Icon,
    MessageCircleIcon,
    MicrophoneIcon,
    MicrophoneOffIcon,
    PauseIcon,
    PlayIcon,
    PlayCircleIcon,
    PlayFilledIcon,
    PlusIcon,
    RectangleIcon,
    RedactionIcon,
    RedoArrowIcon,
    RefreshIcon,
    SandglassIcon,
    SaveIcon,
    ScreenshotIcon,
    SearchIcon,
    SecurityIcon,
    SendIcon,
    ShapesIcon,
    ShareIcon,
    ShareStrokeIcon,
    ShowIcon,
    SlidesIcon,
    StampIcon,
    StrategyIcon,
    StrokeWidthIcon,
    TakeawaysIcon,
    TelevisionIcon,
    TranscriptionIcon,
    TrashIcon,
    TrashCrossIcon,
    UndoArrowIcon,
    UserCheckIcon,
    UserIcon,
    UserLockIcon,
    VerticalDotsIcon,
    VideoIcon,
    VideoCutIcon,
    WarningIcon,
  ],
})
export class MibIconsModule {}
